import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "months": {
      "column": {
        "default": null,
        "name": "months",
        "null": false,
        "type": "integer"
      },
      "name": "months",
      "selected_by_default": null,
      "translated": false
    },
    "plan_resource_id": {
      "column": {
        "default": null,
        "name": "plan_resource_id",
        "null": false,
        "type": null
      },
      "name": "plan_resource_id",
      "selected_by_default": null,
      "translated": false
    },
    "stripe_plan_id": {
      "column": {
        "default": null,
        "name": "stripe_plan_id",
        "null": true,
        "type": null
      },
      "name": "stripe_plan_id",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "PlanResourcePeriod",
  "collectionKey": "plan_resource_periods",
  "collectionName": "plan_resource_periods",
  "i18nKey": "plan_resource_period",
  "camelizedLower": "planResourcePeriod",
  "name": "PlanResourcePeriod",
  "nameDasherized": "plan-resource-period",
  "pluralName": "plan_resource_periods",
  "ransackable_associations": [
    {
      "className": "PlanResourcePeriod::Audit",
      "collectionName": "plan_resource_period_audits",
      "foreignKey": "plan_resource_period_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "PlanResourcePeriodAudit",
      "through": null
    },
    {
      "className": "PlanResourcePeriod::Audit",
      "collectionName": "plan_resource_period_audits",
      "foreignKey": "plan_resource_period_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "PlanResourcePeriodAudit",
      "through": null
    },
    {
      "className": "PlanResourcePeriod::Translation",
      "collectionName": null,
      "foreignKey": "plan_resource_period_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "PlanResource",
      "collectionName": "plan_resources",
      "foreignKey": "plan_resource_id",
      "name": "plan_resource",
      "macro": "belongs_to",
      "resource_name": "PlanResource",
      "through": null
    },
    {
      "className": "PlanResourcePeriodPrice",
      "collectionName": "plan_resource_period_prices",
      "foreignKey": "plan_resource_period_id",
      "name": "prices",
      "macro": "has_many",
      "resource_name": "PlanResourcePeriodPrice",
      "through": null
    },
    {
      "className": "StripePlan",
      "collectionName": "stripe_plans",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_plan",
      "macro": "belongs_to",
      "resource_name": "StripePlan",
      "through": null
    },
    {
      "className": "PlanResourcePeriod::Translation",
      "collectionName": null,
      "foreignKey": "plan_resource_period_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "months",
      "column": {
        "default": null,
        "name": "months",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "plan_resource_id",
      "column": {
        "default": null,
        "name": "plan_resource_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "stripe_plan_id",
      "column": {
        "default": null,
        "name": "stripe_plan_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "PlanResource",
      "collectionName": "plan_resources",
      "foreignKey": "plan_resource_id",
      "name": "plan_resource",
      "macro": "belongs_to",
      "resource_name": "PlanResource",
      "through": null
    },
    {
      "className": "PlanResourcePeriodPrice",
      "collectionName": "plan_resource_period_prices",
      "foreignKey": "plan_resource_period_id",
      "name": "prices",
      "macro": "has_many",
      "resource_name": "PlanResourcePeriodPrice",
      "through": null
    },
    {
      "className": "StripePlan",
      "collectionName": "stripe_plans",
      "foreignKey": "stripe_plan_id",
      "name": "stripe_plan",
      "macro": "belongs_to",
      "resource_name": "StripePlan",
      "through": null
    }
  ],
  "paramKey": "plan_resource_period",
  "primaryKey": "id"
}

/** Frontend model for PlanResourcePeriod. */
class PlanResourcePeriod extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  months() {
    return this.readAttributeUnderscore("months")
  }

  /** @returns {boolean} */
  hasMonths() {
    const value = this.months()

    return this._isPresent(value)
  }

  /** @returns {any} */
  planResourceId() {
    return this.readAttributeUnderscore("plan_resource_id")
  }

  /** @returns {boolean} */
  hasPlanResourceId() {
    const value = this.planResourceId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  stripePlanId() {
    return this.readAttributeUnderscore("stripe_plan_id")
  }

  /** @returns {boolean} */
  hasStripePlanId() {
    const value = this.stripePlanId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {import("./plan-resource.js").default | null} */
  planResource() {
    return this._readBelongsToReflection({reflectionName: "plan_resource"})
  }

  /** @returns {Promise<import("./plan-resource.js").default | null>} */
  loadPlanResource() {
    if (!("planResourceId" in this)) throw new Error("Foreign key method wasn't defined: planResourceId")

    const id = this.planResourceId()
    const modelClass = modelClassRequire("PlanResource")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "plan_resource", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./plan-resource-period-price.js").default>} */
  prices() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PlanResourcePeriodPrice")

    const ransack = {}

    ransack["plan_resource_period_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "prices",
        model: this,
        modelName: "PlanResourcePeriodPrice",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./plan-resource-period-price.js").default>>} */
  loadPrices() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("PlanResourcePeriodPrice")

    const ransack = {}

    ransack["plan_resource_period_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "prices",
        model: this,
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {import("./stripe-plan.js").default | null} */
  stripePlan() {
    return this._readBelongsToReflection({reflectionName: "stripe_plan"})
  }

  /** @returns {Promise<import("./stripe-plan.js").default | null>} */
  loadStripePlan() {
    if (!("stripePlanId" in this)) throw new Error("Foreign key method wasn't defined: stripePlanId")

    const id = this.stripePlanId()
    const modelClass = modelClassRequire("StripePlan")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "stripe_plan", model: this, modelClass},
      {ransack}
    )
  }
}

export default PlanResourcePeriod
